import { useEffect, useState } from "react";
import { getSetting, resolveMediaUrl } from "../lib/api";

const FALLBACK_VIDEOS = [
  "https://customer-assets.emergentagent.com/job_her-box-studio/artifacts/7h56jhg1_WhatsApp%20Video%202026-05-01%20at%2012.33.11%20PM.mp4",
  "https://customer-assets.emergentagent.com/job_her-box-studio/artifacts/ry9f3xh8_WhatsApp%20Video%202026-05-01%20at%2012.35.12%20PM.mp4",
  "https://customer-assets.emergentagent.com/job_her-box-studio/artifacts/xmpcimmc_WhatsApp%20Video%202026-05-01%20at%2012.35.13%20PM.mp4",
];

export default function ProductVideos() {
  const [videos, setVideos] = useState(FALLBACK_VIDEOS);
  useEffect(() => {
    getSetting("home_videos")
      .then((s) => {
        if (s && Array.isArray(s.value) && s.value.length > 0) setVideos(s.value);
      })
      .catch(() => {});
  }, []);
  return (
    <section data-testid="product-videos" className="bg-[#0A0A0A] py-16 md:py-20 border-t border-[#262626]">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="text-center mb-10">
          <div
            className="font-ui mb-3"
            style={{ fontSize: 12, fontWeight: 600, color: "#F5D565", letterSpacing: "0.4em", textTransform: "uppercase" }}
          >
            ✦ In Motion
          </div>
          <h2
            className="font-serif-display"
            style={{ fontSize: 44, color: "#FFFFFF", lineHeight: 1, fontWeight: 500 }}
          >
            Slow. <em className="gold-text not-italic font-light">Cinematic.</em> Hers.
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {videos.slice(0, 3).map((src, i) => (
            <div
              key={i}
              data-testid={`product-video-${i}`}
              className="relative aspect-[3/4] overflow-hidden bg-[#141414] border border-[#1a1a1a]"
            >
              <video
                src={resolveMediaUrl(src)}
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
